import { UseMutationDefaultOptions } from '@front/hook/Api/common';
import { DEFAULT_TIMEOUT } from '@front/hook/Api/utils/consts';
import { signalToTimeout } from '@front/hook/Api/utils/signalToTimeout';
import { ImportTaskRepository } from '@front/repository/Api/ImportTask';
import type { IImportTaskRepository } from '@front/repository/Api/ImportTask/interface';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { importTaskQueryKeys } from './queryKeys';

const repository = new ImportTaskRepository();

export const _start = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (params: IImportTaskRepository.Start.Params) => {
      return repository.start(params, { signal: signalToTimeout(DEFAULT_TIMEOUT.MUTATION_WITH_JOB_DISPATCH) });
    },
    onSuccess: (_data, variables) => {
      void queryClient.invalidateQueries({
        queryKey: importTaskQueryKeys.listPrefix(variables.projectId),
      });
    },
    ...UseMutationDefaultOptions,
  });
};
